import { render, staticRenderFns } from "./history-meal.vue?vue&type=template&id=739c4ba1&scoped=true"
import script from "./history-meal.vue?vue&type=script&lang=ts"
export * from "./history-meal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "739c4ba1",
  null
  
)

export default component.exports